import { propOr } from 'ramda';
import { errors, REQUEST_ERROR } from './coreApi';

export const SET_TECHNICAL_ERROR = 'DRSA/ERROR/SET_TECHNICAL_ERROR';
export const CLEAR_TECHNICAL_ERROR = 'DRSA/ERROR/CLEAR_TECHNICAL_ERROR';

const reducer = (state = {}, action = {}) => {
  switch (action.type) {
    case SET_TECHNICAL_ERROR:
      return { ...state, display: true, event: action.event, errorCode: action.errorCode || state.errorCode };
    case REQUEST_ERROR:
      return { ...state, ...action.error };
    case CLEAR_TECHNICAL_ERROR:
      return {};
    default:
      return state;
  }
};

export const setTechnicalError = data => () => {
  if (data) {
    const event = propOr(data, 'event', data);
    const errorCode = propOr(errors[data], 'errorCode', data);
    return { type: SET_TECHNICAL_ERROR, errorCode, event };
  }
  return { type: SET_TECHNICAL_ERROR };
};

export const clearTechnicalError = () => ({ type: CLEAR_TECHNICAL_ERROR });

export const actions = {
  setTechnicalError,
  clearTechnicalError,
};

export default { reducer, actions };
